// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

import * as React from "react";
import {
	matchPath as matchRouterPath,
	useLocation as useRouterLocation,
} from "react-router";
import {
	Link as RouterLink,
	NavLink as RouterNavLink,
	Redirect as RouterNavigate,
	Route as RouterRoute,
	Router as RouterRouter,
	Switch as RouterRoutes,
	useHistory as useRouterHistory,
} from "react-router-dom";

export const useHistory = useRouterHistory;
export const useLocation = useRouterLocation;
// V6 -> V5
export const matchPath = ({ end, ...pattern }, pathname) =>
	matchRouterPath(pathname, {
		...pattern,
		exact: end,
	});

export const Link = RouterLink;
export const NavLink = RouterNavLink;
export const Navigate = RouterNavigate;
export const Router = RouterRouter;
export const Routes = RouterRoutes;
// V6 -> V5
export const Route = ({ element, ...rest }) => (
	// eslint-disable-next-line react/jsx-props-no-spreading
	<RouterRoute {...rest}>{element}</RouterRoute>
);
